import React from 'react'
import PropTypes from 'prop-types'

// TODO: use selectpicker

const TenantUserSelect = ({
  selecting,
  onStartSelecting,

  selectedTenantId,
  selectedTenantName,
  onTenantSelect,
  tenantOptions,

  selectedUserId,
  selectedUserName,
  onUserSelect,
  userOptions,

  onSave
}) => (
  <div className='hor-menu' id='stickySelectors'>
    {/* // the selector is open, display tenant and user selects */}
    <ul
      className='nav navbar-nav tenant-menu-options'
      style={{
        display: selecting ? 'block' : 'none'
      }}
    >
      <li>
        {/* a list of tenants */}
        <select
          className='selectpicker form-control'
          data-live-search='true'
          value={selectedTenantId}
          onChange={onTenantSelect}
        >
          <option value=''>No partner selected</option>
          {tenantOptions}
        </select>
      </li>

      <li>
        {/* a list of users */}
        <select
          className='selectpicker form-control'
          data-live-search='true'
          value={selectedUserId}
          onChange={onUserSelect}
        >
          <option value=''>No user selected</option>
          {userOptions}
        </select>
      </li>

      <li>
        {/* save the selection */}
        <button onClick={onSave} className='btn btn green'>
          <i className='fa fa-check' />
        </button>
      </li>
    </ul>
    {/* the selector is closed, display tenant and user */}
    <ul
      className='nav navbar-nav tenant-menu-select'
      style={{ display: selecting ? 'none' : 'block' }}
    >
      <li>
        <a onClick={onStartSelecting}>
          {' '}
          {/* Click this to open selector */}
          {selectedTenantId || selectedUserId // one is defined, so show the name
            ? `${selectedTenantName} | ${selectedUserName}`
            : 'Click to select partner and brand' // neither is defined, show generic message
          }
        </a>
      </li>
    </ul>
  </div>
)

TenantUserSelect.displayName = 'TenantUserSelect'

TenantUserSelect.propTypes = {
  selecting: PropTypes.bool.isRequired,
  onStartSelecting: PropTypes.func.isRequired,

  selectedTenantId: PropTypes.string,
  selectedTenantName: PropTypes.string,
  onTenantSelect: PropTypes.func.isRequired,
  tenantOptions: PropTypes.array.isRequired,

  selectedUserId: PropTypes.string,
  selectedUserName: PropTypes.string,
  onUserSelect: PropTypes.func.isRequired,
  userOptions: PropTypes.array.isRequired,

  onSave: PropTypes.func.isRequired
}

export default TenantUserSelect



// WEBPACK FOOTER //
// ./src/components/header/tenant-user-select/tenant-user-select.js